import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../services/Api";
import { useAuth } from "../../services/AuthContext";
import { Eye, EyeOff } from "lucide-react";
export const PASSWORDLENGTH = 8;

//Creates a component
const LoginPage = () => {
  //sets some functions and states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  // State to store validation errors
  const [inputErrors, setInputErrors] = useState({
    email: "",
    password: "",
  });

  // Validation function
  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Validate username
    if (!email) {
      newErrors.email = "Email is required";
      valid = false;
    }

    // Validate password (minimum 4 characters)
    if (!password) {
      newErrors.password = "Password is required";
      valid = false;
    }

    setInputErrors(newErrors);
    return valid;
  };

  //function that is called when login button is submitted
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!validateForm()) {
      setIsLoading(false);
      return;
    }

    try {
      //calls post function "login"
      const response = await login(email, password);
      if (response.token) {
        localStorage.setItem("token", response.token);
        await checkAuth();
        navigate("/landingpage");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="container">
        {/* Outer Row */}
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            <div className="card o-hidden border-0 shadow-lg mb-4">
              <div className="card-body p-0">
                {/* Nested Row within Card Body */}
                <div className="row">
                  <div className="col-lg-2 d-none d-lg-block bg-login-image" />
                  <div className="col-lg-8">
                    <div className="p-4">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>
                      </div>
                      <form className="user">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control form-control-user"
                            id="exampleInputEmail"
                            name="email"
                            aria-describedby="emailHelp"
                            placeholder="Email Address"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                          />
                        </div>
                        {inputErrors.email && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "24px",
                              fontWeight: "bold",
                            }}
                          >
                            {inputErrors.email}
                          </p>
                        )}
                        <div className="form-group position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control form-control-user"
                            name="password"
                            id="exampleInputPassword"
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                          />
                          <span
                            className="passwordToggle"
                            onClick={togglePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <EyeOff /> : <Eye />}
                          </span>
                        </div>
                        {inputErrors.password && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "24px",
                              fontWeight: "bold",
                            }}
                          >
                            {inputErrors.password}
                          </p>
                        )}
                        {error && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "24px",
                              fontWeight: "bold",
                            }}
                          >
                            {error}
                          </p>
                        )}
                        <div className="form-group">
                          <div className="custom-control custom-checkbox small">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customCheck"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="customCheck"
                            >
                              Remember Me
                            </label>
                          </div>
                        </div>
                        <button
                          onClick={handleLogin}
                          className={`longer-btn p-3 ${
                            isLoading ? "opacity-50 cursor-not-allowed" : ""
                          }`}
                          disabled={isLoading}
                        >
                          {isLoading ? "Logging in..." : "Login"}
                        </button>
                      </form>
                      <hr />
                      <div className="text-center">
                        <Link
                          to="/create-account"
                          style={{ textDecoration: "none" }}
                          className="editing-btn p-1"
                        >
                          Create Account
                        </Link>
                      </div>
                      <div className="text-center">
                        <Link
                          to="/forgot-password"
                          style={{ textDecoration: "none" }}
                          className="editing-btn p-1"
                        >
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
